<template>
  <MeetingModule>
    <div class="tw-flex tw-flex-col tw-gap-8">
      <c-banner v-if="!selectedTimeline" type="negative">
        Er is iets misgegaan bij het ophalen van de tijdlijn.
      </c-banner>

      <ol v-if="selectedTimeline" class="tw-flex tw-flex-col tw-gap-6">
        <dynamic-planning-section
          v-for="group in selectedTimeline.groups"
          :key="group.id"
          class="tw-flex tw-flex-col tw-gap-2"
          :group
          v-model="model"
        />
      </ol>

      <c-banner
        v-if="showStatusMessage"
        class="tw-max-w-full md:tw-max-w-[75%]"
        type="warning"
      >
        <span v-html="statusMessage.message" />
      </c-banner>
    </div>
  </MeetingModule>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import MeetingModule from "components/meeting/modules/MeetingModule.vue";
import DynamicPlanningSection from "components/meeting/modules/dynamic-planning-elements/DynamicPlanningSection.vue";
import {
  operators,
  TRANSITION_MEETING_DEFAULT_STATUS,
  TRANSITION_MEETING_DEFAULT_STATUS_MESSAGE,
} from "models/meeting/transitionMeetingModel";
import { cloneDeep } from "lodash";

// Meeting object
const model = defineModel({
  required: true,
  type: Object,
});

// Timeline
const selectedTimeline = computed(() => {
  return model.value.selected_timeline;
});

const initialStatus = ref(null);

const statusMessage = computed(() => {
  model.value.status = TRANSITION_MEETING_DEFAULT_STATUS;
  let meetingStatusMessage = TRANSITION_MEETING_DEFAULT_STATUS_MESSAGE;
  let _status = TRANSITION_MEETING_DEFAULT_STATUS;

  const { status_conditions = null } = selectedTimeline.value || {};

  if (!status_conditions || !status_conditions.length) {
    return meetingStatusMessage;
  }

  status_conditions.forEach(({ field, operator, value, status, message }) => {
    let modelValue = model.value.timeframe_settings[field];

    if (!modelValue) {
      return;
    }

    if (!(modelValue instanceof Date)) {
      modelValue = new Date(modelValue);
    }

    // Currenty we always use the current date
    value = new Date();

    if (operators[operator] == null) {
      throw new Error(`Invalid operator: ${operator}`);
    }

    if (operators[operator](modelValue, value)) {
      _status = status;
      model.value.status = status;
      meetingStatusMessage = message;
    }
  });

  return { message: meetingStatusMessage, status: _status };
});

const showStatusMessage = computed(() => {
  const { status = null } = statusMessage.value;

  if (!selectedTimeline.value || !status) {
    return false;
  }

  if (
    !model.value.isNewMeeting &&
    (status === "concept" || initialStatus.value === status)
  ) {
    return false;
  }

  return true;
});

onMounted(() => {
  initialStatus.value = cloneDeep(statusMessage.value?.status);
});
</script>
